<template>
  <ul class="nav-list">
    <li
      class="nav-item"
      v-for="(navItem, index) in navItems"
      :key="navItem.title"
      :class="{ 'has-children': navItem.children }"
    >
      <div v-if="navItem.children" class="menu-item-with-children">
        <div class="nav-link" @click="toggleSubmenu(index, $event)">
          {{ navItem.title }}
          <span class="dropdown-icon lg:ml-1">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="14"
              height="14"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <polyline points="6 9 12 15 18 9"></polyline>
            </svg>
          </span>
        </div>
        <ul class="submenu" v-show="openedSubmenu === index">
          <li
            v-for="child in navItem.children"
            :key="child.title"
            class="submenu-item"
          >
            <div
              v-if="child.emit"
              class="submenu-link cursor-pointer"
              @click="() => $emit(child.emit)"
            >
              {{ child.title }}
            </div>
            <router-link v-else :to="child.route" class="submenu-link">
              {{ child.title }}
            </router-link>
          </li>
        </ul>
      </div>
      <template v-else>
        <div
          v-if="navItem.emit"
          class="nav-link"
          @click="() => $emit(navItem.emit)"
        >
          {{ navItem.title }}
        </div>
        <router-link v-else :to="navItem.route" class="nav-link">
          {{ navItem.title }}
        </router-link>
      </template>
    </li>
  </ul>
</template>

<script>
import { defineComponent } from "vue";
export default defineComponent({
  data() {
    return {
      navItems: [
        {
          title: "Басты бет",
          route: { name: "home" },
        },
        {
          title: "Қажылар",
          route: { name: "hajis" },
        },
        {
          title: "Туроператорлар",
          route: { name: "tour_operators" },
        },
        {
          title: "Медиа",
          route: { name: "media" },
          children: [
            {
              title: "Жаңалықтар",
              route: { name: "category_view", params: { slug: "news" } },
            },
            {
              title: "Мақалалар",
              route: { name: "category_view", params: { slug: "articles" } },
            },
            {
              title: "Сұрақ-жауаптар",
              route: { name: "category_view", params: { slug: "qa" } },
            },
            {
              title: "Бейнероликтер",
              route: { name: "video_section" },
            },
            {
              title: "Фотогалерея",
              route: { name: "photo_section" },
            },
            {
              title: "Кітапхана",
              route: { name: "book_section" },
            },
          ],
        },
        {
          title: "Қажылық және Ұмра",
          route: { name: "media" },
          children: [
            {
              title: "Қажылық және Ұмра",
              route: { name: "category_view", params: { slug: "umrah-hajj" } },
            },
            {
              title: "Қасиетті орындар",
              route: { name: "holy_places" },
            },
            {
              title: "Онлайн трансляция",
              emit: "open-live-streaming",
              route: { name: "media" },
            },
            {
              title: "3D тур",
              route: { name: "media" },
            },
          ],
        },
        // {
        //   title: "Байланыс",
        //   route: { name: "media" },
        // },
      ],
      openedSubmenu: null,
      isDesktop: false,
    };
  },
  mounted() {
    document.addEventListener("click", this.handleClickOutside);
    this.checkScreenSize();
    window.addEventListener("resize", this.checkScreenSize);
  },
  beforeUnmount() {
    document.removeEventListener("click", this.handleClickOutside);
    window.removeEventListener("resize", this.checkScreenSize);
  },
  methods: {
    toggleSubmenu(index, event) {
      if (this.openedSubmenu === index) {
        this.openedSubmenu = null;
      } else {
        this.openedSubmenu = index;
      }

      // Предотвращаем всплытие события
      event.stopPropagation();
    },
    handleClickOutside() {
      // Закрываем меню при клике вне его
      if (this.isDesktop) {
        this.openedSubmenu = null;
      }
    },
    checkScreenSize() {
      this.isDesktop = window.innerWidth >= 1024;
    },
  },
});
</script>

<style scoped lang="scss">
.nav-list {
  @apply flex flex-col;
  @apply lg:flex-row lg:items-center lg:gap-[40px];

  .nav-item {
    @apply relative;

    .nav-link {
      font-weight: 600;

      @apply flex p-3 px-4 lg:p-0 rounded-xl;
      @apply text-[16px] lg:text-[15px] leading-[21px] text-white opacity-60 lg:opacity-100 lg:text-[#222222];

      &.router-link-active {
        @apply text-green-600 bg-[#142020] lg:bg-transparent opacity-100;
      }

      &:hover {
        @apply bg-[#142020] lg:bg-transparent opacity-100;
      }
    }

    .menu-item-with-children {
      @apply relative;

      .nav-link {
        @apply cursor-pointer flex items-center;
      }

      .dropdown-icon {
        @apply absolute right-4 top-3 lg:static;
      }
    }
  }

  .submenu {
    @apply flex flex-col;
    @apply ml-5 lg:ml-0;
    @apply lg:absolute lg:top-full lg:left-0 lg:min-w-[246px] lg:bg-white lg:rounded-2xl lg:z-10 lg:mt-2 lg:p-2;
    @apply lg:shadow-[0_4px_4px_-1px_rgba(12,12,13,0.05),0_16px_32px_-1px_rgba(12,12,13,0.1)];

    .submenu-item {
      @apply w-full;

      .submenu-link {
        @apply block p-3 px-4 rounded-xl;
        @apply text-[16px] lg:text-[15px] leading-[21px] text-white opacity-60 lg:opacity-100 lg:text-[#222222];
        @apply lg:p-3 lg:px-4 lg:rounded-lg lg:hover:bg-[#F1F1F1];

        &.router-link-active {
          @apply text-green-600 bg-[#142020] lg:bg-[#F1F1F1] opacity-100;
        }
      }
    }
  }
}
</style>
